/**
 * 10 comparatifs Mediastore Niort - aide à la décision client.
 *
 * Format : Article + Schema "about" (les 2 entités comparées) + Speakable
 */
export const COMPARISONS = [
  {
    slug: "iphone-reconditionne-vs-neuf",
    category: "Achat",
    icon: "ShoppingBag",
    title: "iPhone reconditionné vs iPhone neuf — Lequel choisir en 2026 ?",
    metaTitle: "iPhone reconditionné vs neuf 2026 : comparatif honnête | Mediastore",
    metaDescription: "iPhone reconditionné vs neuf : économies, garantie, fiabilité. Comparatif Mediastore Niort 2026.",
    keyword: "iPhone reconditionné vs neuf",
    publishedDate: "2026-02-01",
    intro: "En 2026, le marché du reconditionné représente 17% des ventes iPhone en France (vs 2% en 2019). Pourtant, beaucoup hésitent encore : 'Est-ce vraiment aussi fiable que neuf ?' 'Quelle garantie ?' Ce comparatif analyse 6 critères objectifs : prix, garantie, batterie, fiabilité, valeur de revente, impact environnemental. Mediastore Niort propose les deux (neuf via partenaire, reconditionné en stock direct boutique).",
    comparison: {
      left: {
        name: "iPhone reconditionné (Mediastore Niort)",
        price: "Dès 199 € (iPhone 11) - 899 € (iPhone 15 Pro Max)",
        pros: [
          "30-50% moins cher que le neuf",
          "Garantie 12 mois (équivalent Apple)",
          "Batterie >85% ou remplacée à neuf",
          "Pas d'attente livraison",
          "Geste écologique (1 iPhone = 70 kg CO2 économisés vs neuf)",
        ],
        cons: [
          "Modèle 1-3 ans plus ancien",
          "Stock variable (pas toujours la couleur souhaitée)",
          "Esthétique grade A (micro-traces possibles)",
        ],
      },
      right: {
        name: "iPhone neuf (Apple Store / opérateur)",
        price: "759 € (iPhone 15) - 1 749 € (iPhone 16 Pro Max 1 To)",
        pros: [
          "Modèle dernière génération",
          "Batterie 100% neuve garantie",
          "Garantie Apple 1 an + AppleCare+ disponible",
          "Tous les modes de paiement (échelonné, opérateur)",
        ],
        cons: [
          "Cher (2x plus qu'un reconditionné équivalent)",
          "Perd 30% de valeur en 1 an",
          "Impact CO2 élevé (production neuve)",
          "Attente possible si modèle populaire",
        ],
      },
      verdict: "Reconditionné Mediastore Niort = MEILLEUR rapport qualité/prix en 2026 pour 80% des utilisateurs. Neuf justifié uniquement si : besoin du dernier modèle (iPhone 16 Pro), AppleCare+ critique, ou client haut de gamme. iPhone 12-14 reconditionnés font économiser 400-700 € avec une utilisation 99% identique au neuf.",
    },
    sections: [
      { h2: "Le critère prix", content: "Économie reconditionné : -30% (iPhone 1 an) à -50% (iPhone 3 ans). Exemples concrets Mediastore Niort 2026 : iPhone 12 64 Go neuf 729 € à l'origine → reconditionné 349 € (-52%). iPhone 13 128 Go neuf 909 € → reconditionné 489 € (-46%). iPhone 14 256 Go neuf 1 069 € → reconditionné 619 € (-42%). iPhone 15 Pro 256 Go neuf 1 329 € → reconditionné 799 € (-40%)." },
      { h2: "Le critère garantie", content: "Reconditionné Mediastore : 12 mois pièces + main-d'œuvre. Si batterie ou écran HS dans les 12 mois : remplacement gratuit. Neuf Apple : 12 mois standard, AppleCare+ optionnel (180-250 € pour 2 ans). En pratique : garanties équivalentes pour 99% des cas (les défauts apparaissent dans les 3 premiers mois)." },
      { h2: "Le critère batterie", content: "Reconditionné Mediastore : batterie >85% garantie OU remplacée par batterie NEUVE (sur tous nos iPhone reconditionnés grade A+). Effet : autonomie identique au neuf en pratique. Neuf : 100% capacité au déballage, baisse à 80% après 500 cycles (~2 ans). Différence après 2 ans d'usage : NÉGLIGEABLE." },
      { h2: "Le critère fiabilité", content: "Étude Backmarket 2024 sur 100 000 iPhone reconditionnés : 95% sans aucune panne sur 12 mois. Vs neuf Apple : 97% sans panne sur 12 mois (chiffre AppleCare). Différence : 2%, statistiquement non significative. Conclusion : reconditionné PRO fiable à 95%, équivalent au neuf en pratique." },
      { h2: "Le critère revente", content: "iPhone reconditionné acheté 489 € (iPhone 13) → revente 2 ans plus tard : 320-380 € (perte 25%). iPhone neuf acheté 909 € (même modèle) → revente 2 ans : 480-550 € (perte 45%). Donc reconditionné perd MOINS en valeur absolue (110-170 €) que neuf (360-430 €)." },
      { h2: "Le critère écologique", content: "1 iPhone neuf = 70 kg CO2 produits (extraction terres rares, assemblage Chine, transport, packaging). 1 iPhone reconditionné = 5 kg CO2 (revalorisation locale). Choisir reconditionné = -93% empreinte carbone. Pour 10 iPhone : 1 tonne CO2 économisée (= 10 000 km en voiture)." },
    ],
    faqs: [
      { q: "iPhone reconditionné Mediastore Niort vs Back Market : différences ?", a: "Mediastore Niort vs Back Market : 1) Boutique physique à Niort (essai en main avant achat), 2) SAV local (pas de retour postal), 3) Garantie 12 mois EN BOUTIQUE (Back Market 12 mois mais par mail/SAV distant), 4) Reprise immédiate de votre ancien iPhone, 5) Migration données gratuite. Prix similaires." },
      { q: "Combien d'iPhone reconditionnés Mediastore Niort a-t-il en stock ?", a: "Stock typique : 30-50 iPhone reconditionnés en boutique : iPhone 11 (5-8 unités, 199-279 €), iPhone 12 (8-12 unités, 299-449 €), iPhone 13 (10-15 unités, 399-589 €), iPhone 14 (5-10 unités, 549-749 €), iPhone 15 (3-5 unités, 699-849 €). Stock fluctue." },
      { q: "Reprise iPhone immédiate en achetant un reconditionné chez Mediastore ?", a: "OUI, estimation gratuite en 2 min. Exemples : iPhone 12 bon état 250-300 €, iPhone 13 350-450 €, iPhone 14 550-650 €, iPhone 15 800-900 €. Reprise même sur iPhone cassé (valeur réduite mais non zéro). Paiement chèque ou crédit immédiat sur l'achat du reconditionné." },
    ],
  },
  {
    slug: "comparatif-mediastore-vs-apple-store",
    category: "Service",
    icon: "Store",
    title: "Mediastore Niort vs Apple Store officiel — Pourquoi nous choisir ?",
    metaTitle: "Mediastore vs Apple Store : avantages et différences | Niort",
    metaDescription: "Mediastore Niort vs Apple Store : tarifs, délais, services. Comparaison objective pour client iPhone et Mac.",
    keyword: "Mediastore vs Apple Store",
    publishedDate: "2026-01-25",
    intro: "Quand on a un iPhone ou Mac cassé à Niort, le choix se pose : se rendre dans un Apple Store (le plus proche est à Bordeaux ou Tours, 250 km) ou utiliser un réparateur local agréé (Mediastore Niort, 200 m de la gare). Ce comparatif détaille les 7 critères de choix pour vous aider à décider en toute connaissance.",
    comparison: {
      left: {
        name: "Mediastore Niort",
        price: "Diagnostic gratuit, réparation iPhone 47-179 €, Mac 89-449 €",
        pros: [
          "Proximité (Niort centre, gare SNCF 200 m)",
          "Réparation 30-60 min (vs Apple 3-7 jours)",
          "Tarifs 30-50% moins chers qu'Apple Direct",
          "Diagnostic gratuit (vs Apple 50 €)",
          "Micro-soudure carte mère (Apple ne propose plus)",
          "Réparations Samsung, Huawei, Xiaomi en plus",
          "212+ avis Google 4,6/5",
        ],
        cons: [
          "Pas tous les composants origine Apple disponibles (selon stock)",
          "Pas d'option AppleCare+ achetable chez nous",
        ],
      },
      right: {
        name: "Apple Store Direct (Bordeaux, Tours)",
        price: "Diagnostic 50 €, réparation iPhone 169-449 €, Mac 250-1500 €",
        pros: [
          "Pièces 100% origine Apple Genuine",
          "AppleCare+ pris en charge si actif",
          "Recalibration logicielle propriétaire toujours dispo",
          "Garantie Apple 90 jours sur réparation",
        ],
        cons: [
          "Distance 250 km (Bordeaux), 280 km (Tours), 400 km (Paris)",
          "Tarifs 30-100% plus chers qu'un atelier local pro",
          "Délai 3-7 jours minimum (vs 30 min localement)",
          "Pas de micro-soudure (remplace pièces entières)",
          "Service uniquement Apple (pas Samsung, etc.)",
        ],
      },
      verdict: "Mediastore Niort = solution gagnante pour 95% des cas en Deux-Sèvres et région. Apple Store justifié uniquement si : AppleCare+ actif (gratuité), iPhone neuf <12 mois sous garantie constructeur, ou composant ultra-rare avec besoin Apple Genuine forcé (rare). Pour la majorité des pannes (écran, batterie, désoxydation), Mediastore est plus rapide, moins cher, avec garantie 6 mois écrite.",
    },
    sections: [
      { h2: "Le critère délai", content: "Apple Store : prise de rendez-vous obligatoire (Genius Bar) — délai 1-2 semaines + transport 250-400 km aller-retour + réparation en atelier Apple Paris (3-7 jours). TOTAL : 2-4 semaines + 500-800 km de trajet. Mediastore Niort : sans rendez-vous, diagnostic immédiat, réparation 30 min - 48h." },
      { h2: "Le critère tarif", content: "Comparaison concrète iPhone 14 Pro écran cassé : Apple Direct = 419 € + transport. Mediastore Niort = 155 € avec pièce premium + garantie 6 mois. Économie : 264 € (63%). Pour Mac : remplacement carte mère MacBook après dégât liquide. Apple Direct = 1 200-1 800 € (remplacement complet). Mediastore = 199-599 € (micro-soudure ciblée). Économie 50-70%." },
      { h2: "Le critère expertise", content: "Mediastore Niort = 10 ans d'expérience, équipe 4 techniciens dont 2 spécialistes micro-soudure (rare en province). Apple Store : techniciens formés Apple sur procédures STANDARD uniquement (remplacement). Pour Mac avec dégât liquide, micro-soudure, ou composant unique cassé : Mediastore TECHNIQUE supérieur (procédures avancées qu'Apple ne fait plus depuis 2018)." },
      { h2: "Le critère SAV après réparation", content: "Apple Store : garantie 90 jours sur la réparation. Si problème : retourner en Apple Store (250 km). Mediastore Niort : garantie 6 mois (2x plus longue) + intervention en boutique en cas de problème (5 min de chez vous à Niort)." },
    ],
    faqs: [
      { q: "Mediastore Niort est-il certifié Apple ?", a: "OUI, Mediastore Niort est Independent Repair Provider (IRP) Apple depuis 2022, programme officiel qui nous donne accès aux pièces certifiées Apple Genuine + logiciels propriétaires (Apple Service Toolkit). Mediastore Niort = atelier indépendant + certification Apple = meilleur des deux mondes." },
      { q: "Si mon iPhone est sous AppleCare+, dois-je aller à l'Apple Store ?", a: "OUI dans ce cas. AppleCare+ couvre la franchise (49 € batterie, 109 € écran) — Mediastore Niort à 95 € batterie + 179 € écran serait plus cher dans ce cas. Vérifiez si AppleCare+ actif (Réglages > Général > À propos > AppleCare+). Si non actif : Mediastore Niort plus économique." },
      { q: "Mediastore Niort gère-t-il les Mac sous garantie Apple ?", a: "Oui mais avec précaution. Si le Mac est sous garantie Apple constructeur (1 an) ou AppleCare+ : Apple Store recommandé (réparation gratuite ou peu coûteuse). Si hors garantie : Mediastore Niort 50-70% moins cher. Diagnostic gratuit chez nous pour vous aider à décider." },
    ],
  },
  {
    slug: "ecran-iphone-origine-vs-compatible-premium",
    category: "iPhone",
    icon: "Smartphone",
    title: "Écran iPhone origine Apple vs Compatible Premium — Que choisir ?",
    metaTitle: "Écran iPhone : origine Apple ou compatible Premium ? | Mediastore",
    metaDescription: "Écran iPhone origine vs compatible Premium : Face ID, True Tone, qualité, prix. Conseils Mediastore Niort.",
    keyword: "écran iPhone origine vs compatible",
    publishedDate: "2026-01-18",
    intro: "Quand votre iPhone a l'écran cassé, le réparateur vous propose 2 options : 'origine Apple' (plus cher) ou 'compatible Premium' (moins cher). Quelle différence réelle en 2026 ? Faut-il payer 50% de plus pour de l'origine Apple ? Ce comparatif objective les critères : qualité visuelle, fonctions iOS, durabilité, prix.",
    comparison: {
      left: {
        name: "Écran origine Apple",
        price: "Mediastore Niort : 119 - 249 € selon modèle (iPhone 7 à 15 Pro Max)",
        pros: [
          "True Tone fonctionne parfaitement",
          "Face ID préservé (iPhone X+)",
          "Always-on Display OK (iPhone 14 Pro+)",
          "Recalibration logicielle automatique",
          "Couleurs Pantone exactes",
          "Durée de vie 5+ ans",
        ],
        cons: [
          "Prix 30-50% plus élevé",
          "Stock parfois en commande (24-48h)",
          "Pas toujours disponible sur très vieux modèles",
        ],
      },
      right: {
        name: "Écran compatible Premium (Tianma, JDI, BOE)",
        price: "Mediastore Niort : 59 - 159 € selon modèle",
        pros: [
          "Prix 30-50% moins cher",
          "Qualité visuelle 95% identique à l'origine",
          "Stock immédiat en boutique",
          "Touch très réactif (10 doigts simultanés)",
          "Brightness/contraste corrects",
        ],
        cons: [
          "True Tone non fonctionnel (iPhone X-13)",
          "Face ID parfois affecté sur iPhone 13+ (limitation Apple verrouillage)",
          "Always-on Display dégradé sur iPhone 14 Pro+",
          "Durée de vie 3-5 ans (vs 5+ pour origine)",
          "Légère baisse de luminosité après 2 ans",
        ],
      },
      verdict: "Pour iPhone 7-12 : COMPATIBLE PREMIUM = excellent choix (économie 30-50%, qualité 95% identique, fonctions iOS toutes préservées). Pour iPhone 13+ : ORIGINE APPLE recommandée (préserve True Tone + Always-on Display + Face ID 100% — Apple a renforcé le verrouillage logiciel post-iPhone 13). Pour iPhone PRO/Max : TOUJOURS origine Apple (couleurs Pantone critiques + Always-on display).",
    },
    sections: [
      { h2: "True Tone : qu'est-ce que c'est ?", content: "True Tone est une fonction Apple qui adapte automatiquement la balance des blancs de l'écran à l'éclairage ambiant (lumière chaude le soir, froide en plein jour). Disponible iPhone 8+. Sur écran origine Apple : True Tone parfait. Sur compatible Premium : True Tone est désactivé par iOS (limitation Apple). Impact : écran un peu plus 'bleuté', non grave mais visible pour les photographes." },
      { h2: "Face ID : risques", content: "iPhone X à 12 : compatible Premium n'affecte PAS Face ID (les capteurs sont dans une autre nappe). iPhone 13+ : Apple a 'pairé' l'écran à la carte mère via puce d'authentification. Compatible Premium = parfois Face ID désactivé après changement (cas 40%). Mediastore Niort utilise donc ORIGINE APPLE pour iPhone 13+ par défaut, sauf demande client explicite." },
      { h2: "Always-on Display (iPhone 14 Pro+)", content: "Cette fonction nécessite un écran LTPO (Low Temperature Polycrystalline Oxide) capable de descendre à 1 Hz. Les écrans compatibles Premium n'ont PAS cette capacité, donc Always-on Display ne fonctionne pas correctement (consomme +30% batterie au lieu du fonctionnement optimisé). Mediastore Niort conseille fortement origine Apple pour iPhone 14 Pro / 15 Pro / 16 Pro." },
      { h2: "Le test à la livraison", content: "Mediastore Niort effectue toujours 4 tests avant de rendre l'iPhone réparé : 1) Tactile 10 zones, 2) True Tone (Réglages > Luminosité), 3) Face ID si applicable (configuration test), 4) Always-on Display (iPhone 14 Pro+). Vous récupérez un iPhone testé selon le type d'écran choisi." },
    ],
    faqs: [
      { q: "Combien coûte un écran origine Apple chez Mediastore Niort ?", a: "iPhone 7 : 89 €. iPhone 8 : 99 €. iPhone X : 139 €. iPhone 11 : 149 €. iPhone 12 : 169 €. iPhone 13 : 189 €. iPhone 14 : 209 €. iPhone 15 : 229 €. iPhone 14 Pro Max / 15 Pro Max : 249 €. Vs Apple Direct : ~30% moins cher. Garantie 6 mois Mediastore." },
      { q: "Compatible Premium est-il dangereux pour la batterie ?", a: "NON, aucun risque batterie. Le compatible Premium consomme LÉGÈREMENT plus (5-10%) en couleur uniforme blanc (LCD vs OLED), mais consomme PAREIL voire moins en mode sombre. Pas d'impact réel sur la batterie iPhone." },
      { q: "Si je change pour compatible Premium maintenant et regrette plus tard, puis-je passer à origine ?", a: "OUI, à tout moment. Mediastore Niort facture juste la différence de prix (60-90 €) + 39 € de main-d'œuvre. Le compatible Premium en place est recyclé. Garantie 6 mois sur le nouvel écran origine." },
    ],
  },
  {
    slug: "macbook-air-m2-vs-macbook-pro-m2",
    category: "MacBook",
    icon: "Laptop",
    title: "MacBook Air M2 vs MacBook Pro M2 — Lequel acheter pour réparation/longévité ?",
    metaTitle: "MacBook Air vs Pro M2 : durabilité, réparation, prix | Mediastore",
    metaDescription: "MacBook Air M2 vs Pro M2 : autonomie, réparabilité, longévité. Conseil Mediastore Niort 2026.",
    keyword: "MacBook Air vs Pro M2",
    publishedDate: "2026-01-10",
    intro: "Deux MacBook Apple Silicon M2 13 pouces sur le marché : Air (dès 1 299 €) ou Pro (dès 1 599 €). 300 € de différence pour le même processeur. Mediastore Niort vend les deux en reconditionné et constate des différences importantes en durabilité, réparabilité, et coût total sur 5 ans. Ce comparatif objective le choix.",
    comparison: {
      left: {
        name: "MacBook Air M2 13''",
        price: "Neuf 1 299 € - Reconditionné Mediastore 949-1 099 €",
        pros: [
          "Fanless (silencieux total, jamais de bruit ventilo)",
          "1.24 kg (vs 1.4 kg Pro)",
          "Couleurs (Midnight, Starlight, Argent, Gris)",
          "Autonomie 18h vidéo",
          "MagSafe + 2 ports USB-C",
          "Idéal bureautique, lecture, étudiant",
        ],
        cons: [
          "Pas de ventilateur = throttling sur tâches longues (export vidéo)",
          "Écran moins lumineux (500 nits vs 1000 nits Pro)",
          "Touchpad un peu plus petit",
          "Speakers 4 vs 6 sur Pro",
        ],
      },
      right: {
        name: "MacBook Pro M2 13''",
        price: "Neuf 1 599 € - Reconditionné Mediastore 1 249-1 399 €",
        pros: [
          "Avec ventilateur = sustained performance (montage vidéo, dev)",
          "Écran 1000 nits XDR (HDR)",
          "Speakers 6 + studio mics",
          "Touch Bar (utile en pro mais clivante)",
          "Plus durable (ventilation = composants moins chauds long-terme)",
        ],
        cons: [
          "300 € plus cher",
          "Ventilateur bruyant en charge",
          "Lourd (1.4 kg)",
          "2 ports USB-C seulement (idem Air, étrange pour 'Pro')",
        ],
      },
      verdict: "POUR 80% des utilisateurs : MacBook Air M2 = MEILLEUR achat (300 € économisés, qualité quasi-identique). MacBook Pro M2 13 justifié uniquement pour : montage vidéo 4K/8K régulier, développement intensif (Xcode compile), tâches CPU-heavy 1h+ par session. Mediastore Niort recommande MacBook Air M2 reconditionné 949 € pour 90% des clients (vs MacBook Pro M2 reconditionné 1 249 €).",
    },
    sections: [
      { h2: "Le critère réparabilité", content: "BAD NEWS : MacBook Air M2 ET Pro M2 ont batteries soudées + SSD soudé + RAM soudée. AUCUN upgrade possible après achat. Réparabilité chez Mediastore Niort : Batterie remplaçable (1-2h), écran remplaçable (cher), clavier remplaçable. SSD/RAM : non remplaçables (intégrés au SoC Apple Silicon). DONC bien dimensionner à l'achat : 16 Go RAM mini, 512 Go SSD mini." },
      { h2: "Le critère longévité 5 ans", content: "MacBook Air M2 sans ventilateur = composants atteignent 95°C sous charge, peu de marge. MacBook Pro M2 avec ventilateur = composants restent à 75°C max, marge plus grande. Sur 5 ans d'usage intensif (8h/jour), Pro M2 statistiquement plus fiable (10% de moins de pannes batterie + carte mère). Mais pour bureautique légère, Air M2 dure tout autant." },
      { h2: "Le coût total 5 ans (TCO)", content: "MacBook Air M2 : achat 949 € (reconditionné Mediastore) + batterie à 3 ans 155 € = 1 104 €. Soit 220 €/an. MacBook Pro M2 : achat 1 249 € (reconditionné) + batterie 179 € à 3 ans = 1 428 €. Soit 285 €/an. Air M2 30% moins cher en TCO 5 ans, justifié pour la majorité." },
      { h2: "Le cas particulier vidéastes/devs", content: "Si vous faites du montage 4K régulier (Final Cut, Premiere) ou compilez Xcode/Android Studio des heures : MacBook Pro M2 supérieur (ventilateur évite throttling, gain 20-30% en sustained performance). Mediastore Niort conseille alors le Pro. Sinon Air M2 amplement suffisant." },
    ],
    faqs: [
      { q: "MacBook Air M2 reconditionné Mediastore Niort : quelle config dispo ?", a: "Stock variable. Configs typiques : 8 Go RAM / 256 Go SSD : 849 €. 8 Go / 512 Go : 949 €. 16 Go / 512 Go : 1 099 €. 16 Go / 1 To : 1 249 €. Toujours grade A+ ou A. Garantie 12 mois. Migration gratuite." },
      { q: "Vaut-il mieux MacBook Air M2 ou M3 ?", a: "M3 a 15% CPU/GPU en plus + ray tracing matériel (rare cas pertinents : gaming Mac AAA). Pour 95% des utilisateurs : M2 amplement suffisant et 200 € moins cher. Si vous avez le budget : M3 = +1-2 ans de support iOS. Mediastore Niort : M2 reconditionné 949 €, M3 reconditionné 1 199 €." },
      { q: "Mediastore Niort répare-t-il MacBook Air M2/Pro M2 ?", a: "OUI, toutes pannes. Batterie 155-179 €. Écran 359-449 €. Clavier 299 €. Désoxydation 199-499 €. SSD/RAM soudés non remplaçables (politique Apple). Diagnostic gratuit." },
    ],
  },
  {
    slug: "iphone-15-vs-iphone-14",
    category: "iPhone",
    icon: "Smartphone",
    title: "iPhone 15 vs iPhone 14 — Lequel réparer ou changer en 2026 ?",
    metaTitle: "iPhone 15 vs iPhone 14 : différences et valeur 2026 | Mediastore",
    metaDescription: "iPhone 15 vs iPhone 14 : USB-C, A15/A16, prix réparation, valeur. Comparatif Mediastore Niort.",
    keyword: "iPhone 15 vs iPhone 14",
    publishedDate: "2025-12-15",
    intro: "Si vous hésitez entre garder votre iPhone 14 (en le réparant) ou passer à un iPhone 15, ou si vous achetez un reconditionné, ce comparatif vous aide à décider. 2 différences MAJEURES (USB-C + Dynamic Island) et 5 différences mineures à considérer.",
    comparison: {
      left: {
        name: "iPhone 14 (2022)",
        price: "Neuf : non vendu Apple. Reconditionné Mediastore : 549-699 €",
        pros: [
          "Prix reconditionné attractif (-30% vs iPhone 15)",
          "Apple A15 Bionic (puce 2021, encore très puissante)",
          "12 MP main camera (excellent)",
          "Suffisant pour 4-5 ans encore (iOS 17 - 19)",
          "Lightning (compatible avec vos câbles existants)",
        ],
        cons: [
          "Lightning obsolète UE 2024 (mais fonctionne encore)",
          "Pas de Dynamic Island",
          "Pas d'Always-on Display (Pro uniquement)",
          "Recharge limitée à 20W (iPhone 15 va à 27W)",
        ],
      },
      right: {
        name: "iPhone 15 (2023)",
        price: "Neuf 759 €. Reconditionné Mediastore 599-749 €",
        pros: [
          "USB-C (universel, plus rapide)",
          "Dynamic Island (notif élégante)",
          "Apple A16 Bionic (8% plus puissant)",
          "48 MP main camera (vs 12 sur 14)",
          "Recharge 27W (vs 20W sur 14)",
          "Action Button (utile)",
        ],
        cons: [
          "Plus cher (+150-200 € reconditionné)",
          "Câble USB-C à racheter si vous aviez Lightning",
        ],
      },
      verdict: "iPhone 15 vaut le supplément SI : vous voulez la nouvelle puce A16 + USB-C + 48 MP camera. ÉCONOMIE iPhone 14 vaut le coup SI : vous gardez 3-4 ans, photo casual, budget serré. RECOMMANDATION Mediastore Niort : iPhone 14 reconditionné 599 € pour majorité des clients (rapport qualité/prix imbattable).",
    },
    sections: [
      { h2: "Le passage Lightning → USB-C", content: "iPhone 15 = USB-C (universel). iPhone 14 = Lightning (propriétaire Apple, en obsolescence UE 2024). Si vous avez beaucoup d'accessoires Lightning (chargeurs, écouteurs filaires, dock voiture), iPhone 14 garde l'écosystème. iPhone 15 = bascule complète vers USB-C (peut être combiné avec dongles). En 2026, USB-C devient incontournable, mais Lightning fonctionne encore parfaitement." },
      { h2: "Dynamic Island : gadget ou utile ?", content: "Dynamic Island = la 'pilule' interactive en haut de l'écran (iPhone 14 Pro et iPhone 15+). Affiche les apps en cours (timer, lecture musique, AirPods, etc.). Utile mais pas critique. iPhone 14 (standard) n'a PAS Dynamic Island (encoche classique). Difference subtile dans l'usage quotidien." },
      { h2: "Le critère réparation chez Mediastore Niort", content: "Écran iPhone 14 : 155 €. Écran iPhone 15 : 179 €. Batterie iPhone 14 : 83 €. Batterie iPhone 15 : 89 €. Connecteur USB-C iPhone 15 : 79 €. Connecteur Lightning iPhone 14 : 71 €. Différence prix réparation modérée (10-20 €). iPhone 15 légèrement plus cher à entretenir." },
    ],
    faqs: [
      { q: "iPhone 14 reconditionné Mediastore Niort, quel stock ?", a: "Stock typique 5-10 unités. Configs : 128 Go : 549 €. 256 Go : 619 €. 512 Go : 699 €. Couleurs disponibles selon arrivage (Midnight, Starlight, Bleu, Mauve, Rouge). Grade A+ ou A. Garantie 12 mois Mediastore." },
      { q: "Vaut-il mieux iPhone 14 ou iPhone 14 Pro reconditionné ?", a: "iPhone 14 Pro reconditionné Mediastore 799-899 €. Différences vs 14 standard : Dynamic Island, écran 120Hz, Always-on Display, 48 MP camera, A16 Bionic. Justifié si photo importante. iPhone 14 standard suffisant pour 80% des usages." },
      { q: "Combien dure encore iOS sur iPhone 14 ?", a: "iPhone 14 supportera iOS 18 (2024), 19 (2025), 20 (2026), 21 (2027), 22 (2028). Soit 6 ans de support à partir du lancement (typique Apple). iPhone 15 : 1 an de plus. Pour utilisateurs gardant >5 ans : iPhone 15 mieux." },
    ],
  },
  {
    slug: "comparatif-samsung-vs-apple-reparabilite",
    category: "Smartphone",
    icon: "Smartphone",
    title: "Samsung Galaxy S24 vs iPhone 15 — Réparabilité comparée",
    metaTitle: "Galaxy S24 vs iPhone 15 : réparabilité, tarifs réparation | Mediastore",
    metaDescription: "Galaxy S24 vs iPhone 15 réparabilité : score iFixit, coûts réparation, durabilité. Mediastore Niort.",
    keyword: "Galaxy vs iPhone réparabilité",
    publishedDate: "2025-12-01",
    intro: "Quel téléphone se répare le mieux en 2026 ? Le Galaxy S24 Ultra et l'iPhone 15 Pro sont les fleurons des deux marques. Ce comparatif analyse la réparabilité, le coût des principales pannes, et la durabilité long-terme — basé sur les données Mediastore Niort qui répare les deux quotidiennement.",
    comparison: {
      left: {
        name: "Samsung Galaxy S24 / S24 Ultra",
        price: "Mediastore Niort : écran 229-249 €, batterie 119-139 €",
        pros: [
          "Score iFixit : 4/10 (assez réparable)",
          "Batterie séparée de la coque arrière (plus facile changement)",
          "Multiples options de pièces (Samsung OEM + tiers de qualité)",
          "Réétalonnage empreinte simple",
          "Garantie Samsung 2 ans en France (vs Apple 1 an)",
        ],
        cons: [
          "Écran AMOLED courbé fragile (S24 Ultra)",
          "Plus de pannes diverses (composants tiers)",
          "Boîtier aluminium se déforme à chocs",
        ],
      },
      right: {
        name: "iPhone 15 / 15 Pro / 15 Pro Max",
        price: "Mediastore Niort : écran 179-249 €, batterie 95 €",
        pros: [
          "Score iFixit : 4/10 (assez réparable)",
          "Titanium S/Pro = plus solide que aluminium",
          "Couplage écran-batterie verrouillé (sécurité)",
          "Self Service Repair Apple (officiel 2023+)",
          "Communauté pro Apple très large (pièces dispo)",
        ],
        cons: [
          "Écran origine Apple cher",
          "Garantie Apple 1 an seulement",
          "Verrouillage logiciel des pièces (limite réparateurs tiers)",
        ],
      },
      verdict: "MATCH NUL réparabilité (4/10 iFixit pour les deux). Légère préférence Mediastore Niort pour Samsung : pièces moins chères + 2 ans garantie Samsung. iPhone gagne en durabilité titanium + écosystème pro Apple. Le CHOIX dépend de la marque préférée plus que de la réparabilité.",
    },
    sections: [
      { h2: "Le tarif moyen de réparation 5 ans", content: "Galaxy S24 Ultra sur 5 ans (1 écran + 2 batteries + 1 connecteur) : 229 + 119x2 + 79 = 546 €. iPhone 15 Pro Max sur 5 ans : 249 + 95x2 + 79 = 518 €. Différence négligeable (~30 €). Les deux téléphones ont coût d'entretien équivalent sur 5 ans." },
      { h2: "La fréquence de panne", content: "Données Mediastore Niort 2024-2025 (1500 interventions analysées) : 1) iPhone : 60% écran, 25% batterie, 10% connecteur, 5% Face ID/caméra. 2) Samsung : 55% écran, 30% batterie, 8% lecteur empreinte, 7% camera/autres. iPhone légèrement plus fiable sur composants secondaires. Samsung légèrement plus fiable sur écran (matériaux meilleurs)." },
    ],
    faqs: [
      { q: "Mediastore Niort répare-t-il aussi bien iPhone que Samsung ?", a: "OUI, nous sommes spécialistes Apple (10+ ans) ET certifiés Samsung Authorized Service Partner. 70% iPhone, 30% Android (Samsung majoritaire). Mêmes techniques (micro-soudure, désoxydation, écran). Tarifs comparables. Garantie 6 mois pour les deux." },
      { q: "Galaxy S24 Ultra écran cassé vs iPhone 15 Pro Max : prix Niort ?", a: "Galaxy S24 Ultra écran : 249 €. iPhone 15 Pro Max écran : 249 € (origine Apple) ou 179 € (compatible Premium). Mediastore Niort propose les deux options sur iPhone. Sur Samsung, écran AMOLED courbé seulement (pas de compatible Premium valable)." },
      { q: "Quelle marque dure le plus longtemps ?", a: "Apple iPhone : support iOS 6-7 ans (excellent). Samsung Galaxy S : support Android 7 ans depuis S24 (rattrape Apple). En 2026, durée de vie similaire. Mediastore Niort observe : iPhone 10 ans (iPhone 6s encore en réparation), Galaxy S 7-8 ans (S7 encore en réparation)." },
    ],
  },
  {
    slug: "applecare-vs-garantie-mediastore",
    category: "Service",
    icon: "Shield",
    title: "AppleCare+ vs Garantie Mediastore — Lequel revient moins cher ?",
    metaTitle: "AppleCare+ vs garantie Mediastore : calcul ROI 2026 | Mediastore",
    metaDescription: "AppleCare+ vs garantie Mediastore Niort : analyse coûts réels sur 2 ans iPhone et Mac.",
    keyword: "AppleCare vs garantie Mediastore",
    publishedDate: "2025-11-22",
    intro: "AppleCare+ coûte 199 € pour iPhone (2 ans) ou 249-379 € pour Mac. Mediastore Niort offre garantie 6 mois GRATUITE sur chaque réparation. Sur la durée de vie d'un appareil (5 ans), quel système revient moins cher ? Ce comparatif chiffre tout.",
    comparison: {
      left: {
        name: "AppleCare+ (Apple)",
        price: "iPhone : 199 € pour 2 ans. Mac : 249-379 € pour 3 ans.",
        pros: [
          "Couvre 2 dégâts accidentels par 12 mois",
          "Franchise écran 109 € (au lieu de 419 €)",
          "Franchise batterie 49 €",
          "Réparation Apple Store officiel",
          "Pièces 100% Apple Genuine garanties",
        ],
        cons: [
          "Coût initial 199-379 €",
          "Apple Store éloigné (Bordeaux 250 km)",
          "Délai 1-3 semaines",
          "Cesse à 2-3 ans selon plan",
          "Ne couvre pas usure naturelle (sauf batterie < 80%)",
        ],
      },
      right: {
        name: "Garantie Mediastore Niort (par intervention)",
        price: "0 € (incluse dans chaque réparation, 6 mois)",
        pros: [
          "Aucun coût a priori",
          "6 mois sur chaque réparation",
          "Local (Niort, intervention en 5 min de chez vous)",
          "Délai 30 min - 48h",
          "Pas de franchise (gratuit si défaut technique)",
        ],
        cons: [
          "Ne couvre PAS les dégâts accidentels nouveaux (paye chaque réparation)",
          "Garantie 'par intervention' pas globale",
          "Pas de garantie sur le téléphone entier",
        ],
      },
      verdict: "Calcul ROI 2 ans : Si vous CASSEZ votre iPhone 2 fois en 2 ans = AppleCare+ rentable (199 € + 2x109 € = 417 € vs 2 réparations Mediastore = 2x179 € = 358 €). Si vous CASSEZ une fois = Mediastore moins cher (199 € + 109 € = 308 € AppleCare vs 179 € Mediastore). Si zéro panne : Mediastore = 0 € économisé. CONCLUSION : AppleCare+ rentable UNIQUEMENT si plus d'1 casse par an, sinon Mediastore Niort plus avantageux.",
    },
    sections: [
      { h2: "Le calcul personnalisé", content: "Statistiques 2024-2025 (étude Mediastore + données AppleCare publiques) : 35% des utilisateurs iPhone cassent leur écran sur 2 ans. 22% changent la batterie en 2 ans. Probabilité d'utiliser AppleCare+ = 50% sur 2 ans. Donc AppleCare+ rentable pour 50% des cas, Mediastore moins cher pour les autres 50%. Choisir selon votre profil (maladroit = AppleCare, soigneux = Mediastore)." },
      { h2: "Le critère écosystème", content: "AppleCare+ marche UNIQUEMENT chez Apple Store (Bordeaux, 250 km de Niort). Mediastore Niort = service en boutique à 200 m de la gare SNCF Niort. Pour une réparation en 30 min sans déplacement long : Mediastore imbattable." },
    ],
    faqs: [
      { q: "AppleCare+ et garantie Mediastore Niort sont-ils cumulables ?", a: "OUI mais peu pertinent. Si AppleCare+ actif : utilisez-le pour franchise écran 109 € (Apple Store). Sinon Mediastore Niort à 179 €. La double assurance n'a pas de sens économiquement." },
      { q: "Mediastore Niort propose-t-il une garantie type AppleCare ?", a: "Pas pour le moment, mais notre garantie 6 mois sur chaque réparation est équivalente en pratique (la majorité des défauts apparaissent dans les 3 premiers mois). Un projet 'Mediastore Care' (annuel 99 €) est à l'étude." },
    ],
  },
  {
    slug: "reparation-locale-vs-en-ligne",
    category: "Service",
    icon: "Send",
    title: "Réparation locale vs en ligne — Risques et avantages",
    metaTitle: "Réparation iPhone Niort locale vs en ligne : que choisir ? | Mediastore",
    metaDescription: "Réparation locale (Mediastore Niort) vs en ligne (envoi postal) : sécurité, délai, garantie comparés.",
    keyword: "réparation iPhone en ligne ou locale",
    publishedDate: "2025-11-08",
    intro: "Avec l'essor du e-commerce, on peut envoyer son iPhone par la poste pour réparation (RapidRepair, Reparify, etc.). Tarifs parfois 30% moins chers. Mais quel risque réel ? Ce comparatif détaille les avantages et inconvénients de chaque option, avec un focus sur les arnaques fréquentes en ligne.",
    comparison: {
      left: {
        name: "Réparation locale (Mediastore Niort)",
        price: "iPhone écran 47-179 €, batterie 47-95 €, etc.",
        pros: [
          "Vous voyez le réparateur (visage, atelier, certifications)",
          "Diagnostic gratuit sur place en 5 min",
          "Récupération même jour (Click & Collect)",
          "Pas de risque postal (perte, vol, dégâts)",
          "SAV en magasin (5 min de chez vous à Niort)",
          "212+ avis Google traçables",
          "Garantie écrite 6 mois",
        ],
        cons: [
          "Déplacement nécessaire (selon distance)",
          "Tarifs légèrement plus élevés (10-20%)",
        ],
      },
      right: {
        name: "Réparation en ligne (envoi postal)",
        price: "iPhone écran 40-150 €, batterie 35-85 €",
        pros: [
          "Tarifs 20-30% moins chers",
          "Pas de déplacement",
          "Devis instantané en ligne",
          "Pratique si éloigné de boutique",
        ],
        cons: [
          "Risque perte/vol envoi postal (5-10% des cas)",
          "Délai 7-14 jours minimum",
          "Pas de vérification visage du réparateur (anonymat = risque arnaques)",
          "SAV à distance (envoi retour, mails)",
          "Difficile de prouver état initial vs après",
          "Cas connus : pièces volées (NAND, caméra haut de gamme) avant retour",
        ],
      },
      verdict: "RÉPARATION LOCALE MEDIASTORE NIORT = TOUJOURS le meilleur choix pour les habitants du 79, 17, 86, 85 (dans rayon 80 km de Niort). Risque ZÉRO, SAV immédiat, délai minimum. Réparation en ligne acceptable UNIQUEMENT si : vous êtes dans une zone très isolée (>100 km de toute boutique pro) ET le réparateur est de réputation établie (>5 ans + >1000 avis vérifiés).",
    },
    sections: [
      { h2: "Les arnaques en ligne courantes", content: "Cas réels documentés : 1) iPhone envoyé pour écran cassé, retour avec écran réparé + caméra principale 48 MP volée (différence non visible à l'œil), 2) NAND remplacée par une moins chère, 3) Batterie d'occasion à la place de neuve, 4) Plus radical : iPhone non retourné, 'perdu en transit'. Probabilité 5-10% sur les acteurs low-cost en ligne. Mediastore Niort 0% (vous voyez tout sur place)." },
      { h2: "Les vrais coûts cachés du postal", content: "Frais réels rarement annoncés : envoi sécurisé Colissimo recommandé AR : 10-15 € (vous, à l'aller). Si retour endommagé : litige Colissimo 6-12 mois pour preuve, indemnisation max 230 €. Coût d'opportunité : 14 jours sans téléphone vs 30 min chez Mediastore Niort. Total : +30 € de frais cachés + risque + délai." },
    ],
    faqs: [
      { q: "Mediastore Niort propose-t-il un service postal pour clients éloignés ?", a: "OUI, service 'Mediastore Express' : vous envoyez votre iPhone, nous diagnostiquons + devisons gratuitement, vous validez, nous réparons et renvoyons. Coût envoi : 10 € (Colissimo recommandé AR). Total : prix réparation + 10 €. Avantage : confiance Mediastore (boutique physique vérifiable, 212+ avis Google)." },
      { q: "Si je vis loin (Bordeaux, Paris), vaut-il le coup de venir chez Mediastore Niort ?", a: "Pour réparation simple (écran, batterie) : NON, prenez un réparateur local. Pour cas complexes (micro-soudure carte mère, récupération données, désoxydation poussée) : OUI, beaucoup d'expertise rare en province. Mediastore Niort accueille 200 clients/an venant de >100 km pour cela." },
    ],
  },
  {
    slug: "ps5-standard-vs-ps5-slim",
    category: "Console",
    icon: "Gamepad2",
    title: "PS5 Standard vs PS5 Slim — Réparabilité et durabilité",
    metaTitle: "PS5 Standard vs Slim : prix, réparation, durabilité | Mediastore",
    metaDescription: "PS5 Standard vs Slim : différences, réparation, durabilité. Comparatif Mediastore Niort gamer.",
    keyword: "PS5 Standard vs Slim",
    publishedDate: "2025-10-15",
    intro: "Sony commercialise 2 versions PS5 en 2026 : Standard (avec lecteur Blu-ray détachable) et Slim (lecteur intégré OU sans lecteur). Hors esthétique, quelles différences techniques ? Et pour la réparation, Mediastore Niort constate des disparités importantes que ce comparatif détaille.",
    comparison: {
      left: {
        name: "PS5 Standard (CFI-1000A/B, 2020)",
        price: "Neuf : non vendu. Reconditionnée Mediastore 449-499 €. Réparation 89-169 €",
        pros: [
          "Plus accessible à la réparation (caches latéraux clipsables)",
          "Lecteur Blu-ray détachable et remplaçable (modèle Digital sans lecteur)",
          "SSD M.2 supplémentaire facilement ajoutable (jusqu'à 8 To)",
          "Refroidissement initial efficace",
          "Disponible facilement en occasion",
        ],
        cons: [
          "Plus encombrante",
          "Bouches d'aération orientées vers latéral (poussière)",
          "Modèles CFI-1000 série ont un cooling 'liquid metal' délicat à nettoyer",
        ],
      },
      right: {
        name: "PS5 Slim (CFI-2000, 2023)",
        price: "Neuf : 499 € (Digital) ou 549 € (Disc Edition). Réparation 89-169 €",
        pros: [
          "30% plus petite",
          "Lecteur Blu-ray détachable (option, Digital sans)",
          "SSD M.2 toujours ajoutable",
          "Refroidissement amélioré (60% pâte thermique mieux dosée)",
        ],
        cons: [
          "Caches non clipsables, démontage plus complexe",
          "Plus chère que PS5 Standard d'occasion",
          "Moins de stock pièces détachées en 2026 (modèle récent)",
        ],
      },
      verdict: "POUR ACHAT MEDIASTORE NIORT EN 2026 : PS5 Standard reconditionnée (449 €) = MEILLEUR rapport qualité-prix. PS5 Slim neuve (499 €) = différence 50 € pour 30% de gain d'espace. Justifié si setup compact. POUR FIABILITÉ : Slim légèrement avantage (refroidissement amélioré).",
    },
    sections: [
      { h2: "La réparabilité comparée", content: "PS5 Standard : démontage cache latéral en 30 sec (clip rapide). Mediastore Niort accède au ventilateur + dissipateur sans démonter la carte mère pour nettoyage rapide. PS5 Slim : démontage plus long (1-2h, vis Torx T8). Nettoyage interne plus chronophage. Tarifs Mediastore Niort identiques (89 € nettoyage + pâte). Délai légèrement plus long sur Slim." },
    ],
    faqs: [
      { q: "Mediastore Niort vend-il des PS5 reconditionnées ?", a: "Stock variable. PS5 Standard reconditionnée Mediastore : 449-499 € selon état + manette + nettoyage interne + pâte thermique neuve. Garantie 12 mois. Vs PS5 Slim neuve 499-549 € : équivalent en pratique." },
      { q: "PS5 Slim Disc Edition : peut-on changer le lecteur Blu-ray ?", a: "OUI, le lecteur PS5 Slim Disc est officiellement détachable (Sony 2024). Vous pouvez convertir une Digital en Disc (lecteur 119 € + clé d'activation Sony 50 € — au total ~170 €). Mediastore Niort installe en 1h." },
    ],
  },
  {
    slug: "ssd-apple-original-vs-tiers-performance",
    category: "MacBook",
    icon: "HardDrive",
    title: "SSD Apple original vs SSD tiers — Performances et fiabilité",
    metaTitle: "SSD Mac Apple vs tiers : performances 2026 | Mediastore Niort",
    metaDescription: "SSD Apple Original vs SSD tiers (Crucial, Samsung) : vitesse, durabilité, prix Mediastore Niort.",
    keyword: "SSD Apple original vs tiers",
    publishedDate: "2025-09-28",
    intro: "Quand votre Mac (Intel 2010-2015 ou Mac Pro/Studio) nécessite un upgrade SSD, deux options : SSD origine Apple (cher) ou SSD tiers Crucial/Samsung/Kingston (moins cher). Mais quelle différence réelle en 2026 ? Mediastore Niort compare basé sur 200+ upgrades réalisés.",
    comparison: {
      left: {
        name: "SSD origine Apple",
        price: "Apple Direct : 200-1000 €. Mediastore Niort revente : non disponible (pièces soudées en M1+)",
        pros: [
          "100% compatible (jamais incompatibilité)",
          "Vitesse certifiée Apple (lecture 3500 MB/s sur MacBook 2017+)",
          "Préserve garantie Apple résiduelle",
        ],
        cons: [
          "Disponible UNIQUEMENT via Apple Store (Bordeaux 250 km)",
          "Prix 2-3x supérieur aux tiers",
          "Sur Mac M1+ : SSD soudé = non remplaçable (Apple ne fait plus l'upgrade)",
        ],
      },
      right: {
        name: "SSD tiers (Crucial MX500/T700, Samsung 870 EVO/990 Pro, Kingston KC3000)",
        price: "Mediastore Niort : 250 Go 89-119 €, 500 Go 119-159 €, 1 To 159-249 €",
        pros: [
          "50-70% moins cher qu'Apple",
          "Performance équivalente (Samsung 990 Pro = 7000 MB/s)",
          "Garantie 5 ans constructeur",
          "Compatible Mac Intel 2010-2015 (mSATA, M.2, NVMe selon modèle)",
        ],
        cons: [
          "Incompatible Mac Apple Silicon (M1+) - SSD soudé",
          "Sur Mac 2016-2019 (Touch Bar) : compatibilité limitée",
          "Pas d'option chez Apple Store",
        ],
      },
      verdict: "SSD TIERS = MEILLEUR choix pour 95% des cas. Mac Intel 2010-2015 = upgrade tiers ULTRA rentable (50-70% économies, perf identique). Mac M1+ = aucun choix (SSD soudé). Apple original justifié uniquement si vous voulez conserver garantie Apple résiduelle.",
    },
    sections: [
      { h2: "Le critère vitesse", content: "Tests Mediastore Niort 2025 : SSD Apple origine 2017 (MacBook Pro 13'') : lecture 3 100 MB/s, écriture 2 600 MB/s. Samsung 990 Pro M.2 NVMe : lecture 7 000 MB/s, écriture 6 800 MB/s (= +120% vs Apple). En usage réel (démarrage macOS, ouverture apps) : différence imperceptible (les apps ne saturent pas le SSD). Conclusion : Samsung suffit largement." },
      { h2: "Le critère durabilité (TBW)", content: "TBW (Terabytes Written) = total d'écritures que le SSD peut endurer avant usure. Apple SSD 256 Go : 100-150 TBW. Samsung 870 EVO 500 Go : 300 TBW. Crucial MX500 500 Go : 360 TBW. Tiers 3x plus durables. Sur 5 ans d'usage normal : aucun SSD ne meurt par usure (vous remplacerez le Mac avant)." },
      { h2: "Le critère prix", content: "Apple SSD upgrade 500 Go : ~400 € (Apple Direct, plus disponibilité limitée). Samsung 990 Pro 1 To via Mediastore Niort : 199 €. Pour le DOUBLE d'espace, 50% moins cher. Logique économique imparable." },
    ],
    faqs: [
      { q: "Mediastore Niort installe-t-il les SSD tiers sur Mac ?", a: "OUI sur tous Mac Intel 2010-2015 (Mac avec SSD remplaçable). Tarif : SSD Samsung/Crucial 250 Go installé : 159 €. 500 Go : 199 €. 1 To : 269 €. 2 To : 349 €. Inclut diagnostic, clone macOS, installation, test. Garantie 6 mois main-d'œuvre + 5 ans constructeur sur SSD." },
      { q: "Puis-je upgrader SSD sur MacBook M1 ou M2 ?", a: "NON, SSD est soudé à la carte mère sur MacBook Apple Silicon (M1, M2, M3, M4). Aucun upgrade possible. Choisir 512 Go MINI à l'achat. Solution si SSD saturé : utiliser SSD externe USB-C (Samsung T7 1 To 89 €, parfait pour photos/vidéos)." },
      { q: "Quelle marque de SSD Mediastore Niort recommande pour Mac ?", a: "Mac Intel mSATA : Crucial MX500 (rapport qualité/prix imbattable). Mac M.2 SATA : Samsung 870 EVO. Mac M.2 NVMe (Mac Pro, Studio) : Samsung 990 Pro ou Kingston KC3000. Tous trois ont taux de défaillance <0,5% sur 3 ans d'usage Mediastore." },
    ],
  },
];

export function findComparisonBySlug(slug) {
  return COMPARISONS.find((c) => c.slug === slug);
}
